import React from 'react'
import { FormattedMessage } from 'react-intl'

const GlobalInternshipFrom17and18 = require('../data/GlobalInternshipFrom17and18')

const GlobalIntershipTable = ({ langKey, className }) => {
  return (
    <div className={`${className}`}>
      <table className="mb-8">
        <colgroup>
          <col style={{ width: '60%', minWidth: '60%' }}></col>
          <col style={{ width: '40%', minWidth: '40%' }}></col>
        </colgroup>
        <thead>
          <tr>
            <th colSpan="2"><FormattedMessage id="Global Internship Providers in Academic Year 2017/18" /></th>
          </tr>
          <tr>
            <th><FormattedMessage id="Provider Name" /></th>
            <th><FormattedMessage id="Country and Region" /></th>
          </tr>
        </thead>

        <tbody>
          {
            GlobalInternshipFrom17and18.map((item, i) => (
              <tr key={i}>
                <td>{ item.name[langKey] }</td>
                <td className="text-center">{ item.country[langKey] }</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  )
}

GlobalIntershipTable.defaultProps = {
  className: '',
}

export default GlobalIntershipTable
